export default {
  "home.heading.default": "rejoins l'appel",
  "home.heading.loading": "création de la room...",
  "home.heading.join": "prêt à rejoindre ?",
  "home.heading.joined": "t'y es",
  "home.heading.pending": "en attente de l'hôte",
  "home.body.default": "crée une room, lâche le lien, chill.",
  "home.body.loading": "deux sec, on prépare la room.",
  "home.body.join": "check ta cam et ton micro, puis lance-toi.",
  "home.body.joined": "la room est live. partage le lien ou vas-y direct.",
  "home.body.joined_in_room": "dans la room — lance-toi ou partage le lien.",
  "home.body.pending": "la room est verrouillée. l'hôte va te faire entrer.",
  "home.cta.create": "Créer une room",
  "home.cta.join": "Rejoindre la room",
  "home.cta.enter": "Entrer",
  "home.cta.creating": "Création...",
  "home.cta.joining": "Connexion...",
  "home.cta.opening": "Ouverture...",
  "home.cta.pending": "En attente de validation...",
  "home.copy_link": "copier le lien",
  "home.copied": "copié !",
  "home.leave": "quitter la room",
  "home.back": "retour",
  "home.no_participants": "y'a personne pour l'instant",
  "home.join_by_code": "rejoindre avec un code",
  "home.code_placeholder": "entre le code",
  "home.name_placeholder": "ton prénom",
  "home.people_one": "personne",
  "home.people_other": "personnes",
  "home.marketing.invite.title": "Crée une room,\npartage le lien.",
  "home.marketing.invite.body": "Un tap pour lancer. Partage le lien à tes potes et n'importe qui peut rejoindre — pas de téléchargement, pas d'inscription.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Gère ton\npropre style.",
  "home.marketing.look.body": "Filtres couleurs, lissage, vignette — ou floute carrément ton visage. Ta cam, ton style.",
  "home.marketing.host.title": "Ton espace,\ntes règles.",
  "home.marketing.host.body": "Verrouille la room, mute quelqu'un ou vire-le carrément. L'hôte garde le contrôle.",
  "home.marketing.host.locked": "Room verrouillée",
  "home.marketing.host.waiting_to_join": "En attente",
  "home.marketing.host.wants_to_join": "veut rejoindre",
  "home.marketing.anything.title": "Pour tout, en vrai.",
  "home.marketing.anything.body": "Sessions révisions, soirées gaming, points taf, mater un truc ensemble — ou juste chiller.",
  "home.marketing.use_case.study_group": "📚 groupe de révisions",
  "home.marketing.use_case.game_night": "🎮 soirée gaming",
  "home.marketing.use_case.standup": "💼 point taf",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ papotage",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 club de lecture",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "appel terminé",
  "ended.left": "t'as quitté la room.",
  "ended.room_ended": "{title} est terminé pour toi.",
  "ended.rejoin": "revenir",
  "ended.rejoining": "reconnexion...",
  "ended.home": "retour à l'accueil",
  "call.connecting": "connexion",
  "call.waiting": "en attente des autres",
  "call.invite_code": "code d'invit",
  "call.audio_on": "son activé",
  "call.muted": "muté",
  "call.listening": "À l'écoute",
  "call.audio_muted": "Son coupé",
  "call.speaking": "parle",
  "call.you": "toi",
  "call.you_label": "Toi",
  "call.you_suffix": "(toi)",
  "call.chat_placeholder": "envoie un message...",
  "call.guest": "invité",
  "call.room_fallback": "room",
  "call.focus_view": "Vue focus",
  "call.grid_view": "Vue grille",
  "call.swap_main_video": "Changer la vidéo principale",
  "call.open_chat": "Ouvrir le chat",
  "call.close_chat": "Fermer le chat",
  "call.leave_room": "Quitter la room",
  "call.confirm_leave": "Quitter ?",
  "call.mic_on": "Micro activé",
  "call.muted_label": "Muté",
  "call.camera_off": "Caméra coupée",
  "call.connect_failed": "Échec de connexion — check ton internet et réessaie.",
  "call.camera_access_failed": "Impossible d'accéder à ta cam. Check les permissions du navigateur et réessaie.",
  "call.recording_failed": "L'enregistrement n'a pas pu se lancer. L'appel continue sans.",
  "call.initialize_failed": "Un truc a merdé au lancement de l'appel. Actualise et réessaie.",
  "call.participants": "Participants",
  "call.open_participants": "Voir les participants",
  "call.close_participants": "Fermer les participants",
  "call.lock_room": "Verrouiller la room",
  "call.unlock_room": "Déverrouiller la room",
  "call.locked": "verrouillée",
  "call.unlocked": "ouverte",
  "call.kick_member": "Virer de la room",
  "call.mute_member": "Mute",
  "call.unmute_member": "Démute",
  "call.muted_by_host": "Muté par l'hôte",
  "call.waiting_to_join": "Veut rejoindre",
  "call.approve": "Accepter",
  "call.deny": "Refuser",
  "call.profile_actions": "Actions du profil",
  "call.profile_in_room": "Dans la room",
  "call.profile_role_host": "Hôte",
  "call.profile_role_you": "Toi",
  "call.profile_action_mute": "Couper son micro",
  "call.profile_action_mute_meta": "Juste pour toi — la personne ne le saura pas",
  "call.profile_action_dm": "DM",
  "call.profile_action_dm_meta": "Lancer un chat privé",
  "call.profile_action_view": "Voir le profil complet",
  "call.profile_action_view_meta": "Bio, langues, sessions passées",
  "call.profile_action_report": "Signaler",
  "call.profile_action_report_meta": "Signaler à la modération",
  "call.profile_sheet_close": "Fermer les actions",
  "call.profile_open_actions": "Ouvrir les actions",
  "call.dm_title": "Message privé",
  "call.dm_back": "Retour aux actions",
  "call.dm_close": "Fermer le DM",
  "call.dm_status_online": "En ligne",
  "call.dm_in_room_with": "Dans cette room",
  "call.dm_private_label": "Chat privé",
  "call.dm_private_meta": "Y'a que vous deux qui voyez ces messages",
  "call.dm_input_placeholder": "Envoie un DM…",
  "call.dm_send": "Envoyer",
  "call.dm_just_now": "à l'instant",
  "call.dm_seen_just_now": "Vu à l'instant",
  "call.dm_typing": "{name} écrit…",
  "call.dm_minimize": "Réduire",
  "call.dm_active_indicator": "Ouvrir la conversation",
  "call.dm_unread_messages": "{count} non lu(s)",
  "call.dm_toast_tap_to_open": "Appuie pour ouvrir",
  "call.dm_reopen_aria": "Rouvrir la conversation avec {name}",
  "home.join_denied": "L'hôte ne t'a pas laissé entrer.",
  "home.error.room_not_found": "Ce code de room n'existe pas.",
  "home.error.profile_required": "Configure ton profil pour continuer.",
  "home.cta.set_up_profile": "Configurer ton profil",
  "home.profile_trigger_new": "Appuie pour ajouter tes infos",
  "home.profile_trigger_new_aria": "Configurer ton profil",
  "home.profile_trigger_edit_aria": "Modifier ton profil",
  "profile.eyebrow_new": "fais coucou",
  "profile.eyebrow_edit": "ton profil",
  "profile.title_new": "À ton image.",
  "profile.title_edit": "Modifier le profil",
  "profile.subtitle": "Quelques infos rapides pour que les autres sachent à qui ils parlent.",
  "profile.add_photo": "Ajouter une photo",
  "profile.add_photo_soon": "les photos arrivent bientôt",
  "profile.photo_empty": "appuie pour ajouter une photo",
  "profile.photo_ready": "photo prête",
  "profile.photo_save_first": "sauvegarde ton profil avant d'ajouter une photo",
  "profile.photo_crop_caption": "cadre ta photo",
  "profile.photo_auto_caption": "glisse et zoome, on sauvegarde automatiquement",
  "profile.photo_upload": "Importer une photo",
  "profile.photo_replace": "Changer de photo",
  "profile.photo_remove": "Supprimer la photo",
  "profile.photo_cancel": "Annuler",
  "profile.photo_save": "Enregistrer la photo",
  "profile.photo_uploading": "Importation de la photo…",
  "profile.photo_removing": "Suppression de la photo…",
  "profile.photo_choose_another": "En choisir une autre",
  "profile.photo_drag_hint": "Glisse la photo pour la centrer dans le cercle. Ça s'enregistre tout seul.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Recadrage horizontal",
  "profile.photo_vertical": "Recadrage vertical",
  "profile.name_label": "Prénom",
  "profile.name_placeholder": "On t'appelle comment ?",
  "profile.gender_label": "Je suis",
  "profile.gender.woman": "Une femme",
  "profile.gender.man": "Un homme",
  "profile.gender.unspecified": "Je préfère ne pas le dire",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "facultatif",
  "profile.bio_placeholder": "Les langues que tu parles, ce que tu kiffes, ce que tu veux…",
  "profile.cta_new": "C'est parti",
  "profile.cta_edit": "Enregistrer",
  "profile.saving": "Enregistrement…",
  "profile.close": "Fermer",
  "profile.error.save_failed": "Impossible d'enregistrer ton profil. Réessaie.",
  "profile.error.avatar_invalid_type": "Choisis une image PNG, JPEG, GIF ou WebP.",
  "profile.error.avatar_too_large": "Choisis une image de moins de 5 Mo.",
  "profile.error.avatar_too_small": "Choisis une image d'au moins 96x96 pixels.",
  "profile.error.avatar_load_failed": "On n'a pas pu lire cette image. Essaie un autre fichier.",
  "profile.error.avatar_failed": "Impossible d'importer ta photo. Réessaie.",
  "profile.error.avatar_remove_failed": "Impossible de supprimer ta photo. Réessaie.",
  "effects.title": "Effets",
  "effects.soft": "Lissage",
  "effects.vignette": "Vignette",
  "effects.face": "Flou visage",
  "effects.face_preview_only": "Flou visage (aperçu uniquement)",
  "effects.face_viewer_side": "Flou visage (côté spectateur)",
  "effects.face_strength": "Intensité du flou",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "CHAUD",
  "effects.grade.cool": "FROID",
  "effects.grade.bw": "N&B",
  "camera.off": "la cam est coupée",
  "camera.check": "check ta cam",
  "camera.retry": "réessayer la cam",
  "camera.ready": "cam prête",
  "camera.idle.title": "Active ta caméra",
  "camera.idle.hint": "On demandera l'accès à ton navigateur quand tu seras prêt.",
  "camera.idle.button": "Activer la caméra",
  "camera.status.idle": "On t'attend",
  "camera.status.off": "La caméra est coupée",
  "camera.status.loading": "Demande d'accès à la caméra...",
  "camera.status.denied": "Autorise l'accès à la cam dans ton navigateur, puis réessaie.",
  "camera.status.error": "L'aperçu de la cam a planté. Réessaie.",
  "camera.status.unsupported": "Ce navigateur ne gère pas l'accès à la caméra.",
  "camera.status.insecure": "L'accès à la cam nécessite HTTPS ou localhost.",
  "camera.status.attach_failed": "Impossible de lancer l'aperçu de la cam. Réessaie.",
  "camera.guest_name_placeholder": "Nom de l'invité",
  "camera.flip": "Tourner la caméra",
  "camera.save_name": "Enregistrer",
  "camera.edit_name": "Modifier le nom",
  "mic.on": "Couper le micro",
  "mic.off": "Activer le micro",
  "video.on": "Couper la caméra",
  "video.off": "Activer la caméra",
  "chat.title": "chat",
  "chat.close": "Fermer le chat",
  "chat.loading": "chargement...",
  "chat.load_earlier": "charger les messages précédents",
  "chat.empty": "aucun message pour l'instant",
  "chat.send_error": "Le message n'est pas parti — réessaie.",
  "chat.input_placeholder": "écris un message...",
  "room.host": "Hôte",
  "app.room_default_title": "Créer une room",
  "app.chat_connection_rejected": "Le chat n'a pas pu se co — essaie d'actualiser.",
  "app.copy_failed": "Impossible de copier le lien. Essaie de le sélectionner et de le copier à la main.",
  "app.chat_not_connected": "Le chat n'est pas encore co. Attends un instant et réessaie.",
  "footer.terms": "CGU",
  "footer.copyright": "© 2026 Yano.AI"
}
